import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { IProductDataV2, Product } from '@df/catalog/product/product';
import { CarouselSlideDirective } from '@df/ui-carousel/carousel-slide.directive';
import { CarouselComponent } from '@df/ui-carousel/carousel.component';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { addBloomreachRecommendationsVariant } from '../../catalog/ui/page/component/bloomreach-recommendations/bloomreach-recommendations.config';
import { ModelCarouselComponentDef } from '../../catalog/ui/page/component/model-carousel/model-carousel.component.def';
import { getFields } from '../../catalog/ui/page/component/model-carousel/model-carousel.config';
import { ProductComponent } from '../../catalog/ui/product/product.component';

let uid = 0;

const fields = addBloomreachRecommendationsVariant(getFields(Product.type));

fields.splice(2, 0, {
    key: 'link',
    type: NICmsContentField.EFieldType.text,
    title: 'Link'
});

@Component({
    selector: 'basket-upsell-carousel',
    templateUrl: './basket-upsell-carousel.component.html',
    styleUrl: './basket-upsell-carousel.component.scss',
    standalone: true,
    imports: [
        CommonModule,
        CarouselComponent,
        CarouselSlideDirective,
        HrefComponent,
        ICmsClientModule,
        forwardRef(() => ProductComponent),
        TranslatePipe
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<BasketUpsellCarouselComponent>({
    id: 'basket-upsell-carousel',
    name: 'Upsell Carousel',
    onDemandOnly: true,
    fields: fields
})
export class BasketUpsellCarouselComponent
    extends ModelCarouselComponentDef<Product<IProductDataV2>>
    implements NICmsContentComponent.IComponent
{
    readonly uid = `basket-upsell-carousel${uid++}`;

    type = Product.type;

    outletOptions?: NICmsContentComponent.IOutletOptions;

    get hasGiftBox(): boolean {
        return !!this.outletOptions?.context?.hasGiftBox;
    }
}
